import { render } from "./index.vue?vue&type=template&id=53ab7ea0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=53ab7ea0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ab7ea0"],['__file',"src/views/BenefitsOffersDetails/benefitsOffers/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53ab7ea0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53ab7ea0', __exports__)) {
    api.reload('53ab7ea0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=53ab7ea0&scoped=true", () => {
    api.rerender('53ab7ea0', render)
  })

}


export default __exports__